import { render, staticRenderFns } from "./DonorType.vue?vue&type=template&id=d8f5fb26"
import script from "./DonorType.vue?vue&type=script&lang=js"
export * from "./DonorType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports